"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _color = _interopRequireDefault(require("color"));
var _bar = require("cccisd-nivo/bar");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var ComponentChartBar = function ComponentChartBar(props) {
  var _props$settings = props.settings,
    targetLineValue = _props$settings.targetLineValue,
    verticalScaleMin = _props$settings.verticalScaleMin,
    verticalScaleMax = _props$settings.verticalScaleMax,
    scoreSuffix = _props$settings.scoreSuffix,
    showLegend = _props$settings.showLegend,
    showLabels = _props$settings.showLabels,
    colorScheme = _props$settings.colorScheme;
  var getColors = function getColors() {
    var colors = props.colors;
    if (colors) {
      var myColors = [colors.primary];
      for (var i = 1; i < 7; i++) {
        myColors.push((0, _color["default"])(colors.primary).lighten(0.15 * i).hex());
      }
      return myColors;
    }
    return {
      scheme: 'category10'
    };
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      width: '100%',
      height: '300px',
      marginTop: '0.5em'
    }
  }, /*#__PURE__*/_react["default"].createElement(_bar.ResponsiveBar, {
    data: props.data,
    colors: getColors(),
    colorBy: function colorBy(v) {
      if (colorScheme === 'highlightAboveBenchmark') {
        return v.value > targetLineValue;
      }
      return v.id;
    },
    borderWidth: 1,
    padding: 0.2,
    groupMode: "grouped",
    keys: ['Session 1', 'Session 2', 'Session 3', 'Session 4', 'Session 5', 'Session 6', 'Session 7'],
    indexBy: "metric",
    minValue: Number(verticalScaleMin) || 0,
    maxValue: Number(verticalScaleMax) || 100,
    axisLeft: {
      format: function format(n) {
        return "".concat(n).concat(scoreSuffix);
      }
    },
    axisBottom: {
      tickSize: 0
    },
    labelTextColor: "#fff",
    labelFormat: function labelFormat(value) {
      return "".concat(value).concat(scoreSuffix);
    },
    enableLabel: showLabels ? true : false,
    layers: showLegend ? ['grid', 'axes', 'bars', 'markers', 'legends', 'annotations'] : ['grid', 'axes', 'bars', 'markers', 'annotations'],
    markers: targetLineValue ? [{
      axis: 'y',
      value: Number(targetLineValue) || 80,
      lineStyle: {
        stroke: '#b1cbe7',
        strokeWidth: 2,
        strokeDasharray: '10,5'
      },
      legend: '',
      legendOrientation: 'horizontal'
    }] : []
  }));
};
var _default = exports["default"] = ComponentChartBar;